// Default Date Implementation Constants
// These constants define the default date used across the simulation system
// to simplify date/time complexity and improve user experience.

export const DEFAULT_SIMULATION_DATE = "2024-01-15";
export const TIME_FORMAT = "HH:mm";
export const DATETIME_FORMAT = "YYYY-MM-DDTHH:mm:ss";
export const DATE_FORMAT = "YYYY-MM-DD";

// Timezone Strategy Constants
// We use a timezone-agnostic approach where 8am is 8am regardless of user's timezone
// No timezone conversion is performed - times are treated as local times throughout
// This ensures consistent behavior across all timezones
export const TIMEZONE_STRATEGY = {
  BACKEND_EXPECTS_UTC: false,
  FRONTEND_DISPLAYS_LOCAL: true,
  TIMEZONE_LESS_EXPERIENCE: true,
  TIMEZONE_AGNOSTIC: true,
  DATETIME_FORMAT: "YYYY-MM-DDTHH:mm:ss.SSS"
};

// Time validation constants
export const MIN_TIME = "00:00";
export const MAX_TIME = "23:59";

// Default time settings for simulation
export const DEFAULT_TIME_SETTINGS = {
  slope: 2.0,
  intercept: 1200,
  window: 1200,
  multiplier: 1,
  onceOffProcessingTime: 15,
  processingTimes: [
    { seatType: 'standard', processingTimeSeconds: 30 },
    { seatType: 'wheelchair', processingTimeSeconds: 300 },
  ],
};

// Time window presets
export const TIME_WINDOW_PRESETS = {
  'ride-hailing': {
    slope: 1.7,
    intercept: 600,
    window: 900,
    onceOffProcessingTime: 15,
    processingTimes: [
      { seatType: 'standard', processingTimeSeconds: 30 },
      { seatType: 'wheelchair', processingTimeSeconds: 90 },
    ],
  },
  'school-transport': {
    slope: 1.5,
    intercept: 300,
    window: 600,
    onceOffProcessingTime: 30,
    processingTimes: [
      { seatType: 'standard', processingTimeSeconds: 45 },
      { seatType: 'wheelchair', processingTimeSeconds: 120 },
    ],
  },
  'medical-transport': {
    slope: 1.3,
    intercept: 180,
    window: 300,
    onceOffProcessingTime: 60,
    processingTimes: [
      { seatType: 'standard', processingTimeSeconds: 60 },
      { seatType: 'wheelchair', processingTimeSeconds: 180 },
    ],
  },
  'manual': {
    slope: 2.0,
    intercept: 1200,
    window: 1200,
    onceOffProcessingTime: 15,
    processingTimes: [
      { seatType: 'standard', processingTimeSeconds: 30 },
      { seatType: 'wheelchair', processingTimeSeconds: 300 },
    ],
  },
};

// Fixed Routes Constants
export const DEFAULT_TRAFFIC_MULTIPLIER = 1.0;
export const MIN_TRAFFIC_MULTIPLIER = 0.1;
export const MAX_TRAFFIC_MULTIPLIER = 10;
export const DEFAULT_OPERATING_HOURS = {
  startHour: 6, // 6:00 AM
  endHour: 22,  // 10:00 PM
};
export const EXPORT_FILE_PREFIX = 'fixed-routes'; 